
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import TimeRangeSelector, { TimeRange } from "@/components/TimeRangeSelector";

interface DashboardTabsProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
  timeRange?: TimeRange;
  onTimeRangeChange?: (range: TimeRange) => void;
  children: React.ReactNode;
}

const DashboardTabs: React.FC<DashboardTabsProps> = ({
  activeTab,
  setActiveTab,
  timeRange,
  onTimeRangeChange,
  children
}) => {
  return (
    <Tabs defaultValue="overview" value={activeTab} onValueChange={setActiveTab}>
      <div className="flex flex-col md:flex-row justify-between gap-4 mb-4">
        <TabsList className="grid w-full md:w-auto grid-cols-3 md:inline-flex">
          <TabsTrigger value="overview">Dashboard Overview</TabsTrigger>
          <TabsTrigger value="users">User Management</TabsTrigger>
          {/* <TabsTrigger value="videos">Videos Library</TabsTrigger> */}
        </TabsList>

        {activeTab === "overview" && timeRange && onTimeRangeChange && (
          <TimeRangeSelector
            selectedRange={timeRange}
            onRangeChange={onTimeRangeChange}
            className="md:w-auto w-full"
          />
        )}
      </div>

      {children}
    </Tabs>
  );
};

export default DashboardTabs;
